import { Sun, Moon, Monitor } from 'lucide-react';
import { usePortalThemeStore, type ThemeMode } from '@pp/shared/theme/portalThemeStore';

const themeOptions: { value: ThemeMode; label: string; icon: typeof Sun }[] = [
  { value: 'light', label: 'Light', icon: Sun },
  { value: 'dark', label: 'Dark', icon: Moon },
  { value: 'system', label: 'System', icon: Monitor },
];

export function PortalThemeToggle() {
  const { mode, setMode } = usePortalThemeStore();

  return (
    <div className="flex items-center gap-1 p-1 bg-gray-100 dark:bg-gray-700 rounded-lg">
      {themeOptions.map((option) => {
        const Icon = option.icon;
        const isActive = mode === option.value;

        return (
          <button
            key={option.value}
            onClick={() => setMode(option.value)}
            className={`
              flex items-center gap-1.5 px-2.5 py-1.5 text-xs font-medium rounded-md transition-colors
              ${
                isActive
                  ? 'bg-white dark:bg-gray-600 text-blue-600 dark:text-blue-400 shadow-sm'
                  : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200'
              }
            `}
            title={option.label}
            aria-label={`${option.label} theme`}
            aria-pressed={isActive}
          >
            <Icon className="w-3.5 h-3.5" />
            <span className="hidden sm:inline">{option.label}</span>
          </button>
        );
      })}
    </div>
  );
}

export default PortalThemeToggle;
